import { 
    GetDeleteProjectData, 
    CreateProjectData, 
    UpdateProjectData, 
    Project, 
    ReturnProjectData, 
    GetAllProjectsData 
} from "@/types/project";

import { PostRequest, PostRequestFormData } from "./requests";

export const getProjectByID = async (data: GetDeleteProjectData): Promise<Project> => {
    try {
        return await PostRequest<Project>("/api/project/get", data);
    } catch (error) {
        console.log('Error in getProjectByID:', error);
        throw error;
    }
}

export const createProject = async (data: CreateProjectData): Promise<ReturnProjectData> => {
    try {
        const response = await PostRequestFormData("/api/project/create", data);
        return response;
    } catch (error) {
        console.error('Error in createProject');
        throw error;
    }
}

export const getAllProjects = async (data: GetAllProjectsData): Promise<Project[]> => {
    try {
        return await PostRequest<Project[]>("/api/project/get_all", data);
    } catch (error) {
        console.error('Error in getAllProjects');
        throw error;
    }
}

export const updateProject = async (data: UpdateProjectData): Promise<ReturnProjectData> => {
    try {
        return await PostRequestFormData("/api/project/update", data);
    } catch (error) {
        console.error('Error in updateProject');
        throw error;
    }
}

export const deleteProject = async (data: GetDeleteProjectData): Promise<ReturnProjectData> => {
    try {
        return await PostRequest<ReturnProjectData>("/api/project/delete", data);
    } catch (error) {
        console.error('Error in deleteProject');
        throw error;
    }
}
